import { yupResolver } from '@hookform/resolvers/yup';
import React from 'react';
import { FormProvider, SubmitHandler, useForm } from 'react-hook-form';
import * as yup from 'yup';
import { useLocalizationContext } from '../../../Context/LocalizationContext';
import useAssessmentId from '../../../Hooks/useAssessmentId';
import useNavigation from '../../../Hooks/useNavigation';
import { TestInfo } from '../../../Models/TestInfo';
import { RecruitmentLanguage } from './RecruitmentLanguage';

interface WelcomePageFormProps {
    activeTest: TestInfo;
    companyName: string;
}

const validationSchema = yup.object({ locale: yup.string().required('') }).required();

const WelcomePageForm = ({ activeTest, companyName, children }: React.PropsWithChildren<WelcomePageFormProps>) => {
    const { navigateToMonitoringPage } = useNavigation();
    const { availableTestLanguage, activeLanguage, updateTestLanguage } = useLocalizationContext();
    const assessmentId = useAssessmentId();

    // check if the language is predefined (length of 1) or a list of options
    const isApplicantSelect = availableTestLanguage.length > 1;

    const getMatchingLocaleIndex = availableTestLanguage.find((value) => value === activeLanguage);
    const initialLocale = getMatchingLocaleIndex ?? availableTestLanguage[0];

    const initialFormValues: RecruitmentLanguage = {
        locale: initialLocale,
    };

    const form = useForm({
        defaultValues: initialFormValues,
        resolver: isApplicantSelect ? yupResolver(validationSchema) : undefined,
    });

    const saveRecruitmentLanguage: SubmitHandler<RecruitmentLanguage> = async (formValues) => {
        await updateTestLanguage(assessmentId, formValues.locale);
        navigateToMonitoringPage(assessmentId, activeTest, companyName);
    };

    return (
        <FormProvider {...form}>
            <form onSubmit={form.handleSubmit(saveRecruitmentLanguage)}>{children}</form>
        </FormProvider>
    );
};

export default WelcomePageForm;
